import styled from 'styled-components';

/* The single-organisation form of the Organization field (spec AC2): the same label the dropdown
   carries, with the organisation's name as plain text beneath it, in the space the dropdown
   would take. */
export const ConfigImportOrganisation = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;

	.qbo-config-organisation-label {
		font-weight: 500;
	}
`;

/* An option's checkbox sits inside its label (the shared Checkbox drops id, so htmlFor cannot reach
   it). ConfigImportRow styles every label inside it with a left margin, written for a label that
   sits beside its control; the doubled ampersand outranks that rule so this label starts flush and
   lays out the checkbox and the text itself - the same look as before. */
export const ConfigImportOptionLabel = styled.label`
	&& {
		margin-left: 0;
		display: inline-flex;
		align-items: center;
		gap: 10px;
		cursor: pointer;
		line-height: 18px;
	}
`;
